import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
    EnvironmentProviders,
    makeEnvironmentProviders,
    Type,
} from '@angular/core';
import { LicenseUpgradeInterceptor } from '../interceptors/license-upgrade.interceptor';
import { LicenseUpgradeDisplayService } from '../services/license-upgrade-display.abstract-service';

/**
 * @param display the app's `LicenseUpgradeDisplayService` implementation — the
 * dialog host lives in a `feature` library, which a `data-access` one cannot reach.
 * @param standaloneInterceptors use `false` in legacy applications importing
 * `HttpClientModule`, `true` in standalone applications using
 * `provideHttpClient(withInterceptors(licenseUpgradeInterceptor))`
 */
export const provideLicenseUpgrade = (
    display: Type<LicenseUpgradeDisplayService>,
    standaloneInterceptors = true,
): EnvironmentProviders =>
    makeEnvironmentProviders([
        { provide: LicenseUpgradeDisplayService, useExisting: display },
        standaloneInterceptors
            ? LicenseUpgradeInterceptor
            : {
                  provide: HTTP_INTERCEPTORS,
                  useClass: LicenseUpgradeInterceptor,
                  multi: true,
              },
    ]);
